import { Button, Label, StringUtils, TextField } from '@localina/core';
import { EmailIcon } from '@localina/icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSendResetPasswordEmailMutation } from '../../../api/queries/auth';

interface IProps {
    onNext: () => void;
    onLogin: () => void;
    sendResetPasswordEmailMutation: ReturnType<typeof useSendResetPasswordEmailMutation>;
}

const UserInfo: React.FC<IProps> = (props) => {
    const { t } = useTranslation();

    const [email, setEmail] = React.useState('');
    const [emailError, setEmailError] = React.useState<string>();

    const handleEmailChange = (value: string) => {
        setEmail(value);
        setEmailError(undefined);
    };

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const value = email.trim();
        const error = !value
            ? 'auth.errors.emailRequired'
            : !StringUtils.isValidEmail(value)
            ? 'auth.errors.emailInvalid'
            : undefined;
        setEmailError(error);
        if (error) {
            return;
        }

        props.sendResetPasswordEmailMutation.mutate(value, {
            onSuccess: props.onNext,
        });
    };

    const handleBack = () => {
        props.onLogin();
    };

    return (
        <>
            <form className="auth-layout__fields" noValidate onSubmit={handleSubmit}>
                <TextField
                    label={t('resetPassword.fields.email')}
                    name="email"
                    autoComplete="username"
                    type="email"
                    shrink
                    validate={false}
                    startAdornment={<EmailIcon />}
                    value={email}
                    onChange={handleEmailChange}
                    hasError={Boolean(emailError)}
                    errorMessageKey={emailError}
                />
                {props.sendResetPasswordEmailMutation.isError && (
                    <Label type="text" value={t('resetPassword.error')} error={true} />
                )}
                <Button type="submit" label={t('resetPassword.buttons.sendLink')} />
            </form>
            <p className="auth-layout__hint">{t('resetPassword.hint')}</p>
            <button type="button" className="auth-layout__link auth-layout__back" onClick={handleBack}>
                {t('resetPassword.buttons.backToLogin')}
            </button>
        </>
    );
};

export default UserInfo;
